import { lazy } from "react";

export const DomainTagPage = lazy(() => import("./domainTagPage"));
